export const TableHead = [
  "Estate name",
  "Estate address",
  "Phone number",
  "Email address",
  "Action",
];
